import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import imageDefault from '../../../assets/images/svg/ic-image-default.svg';
import { formatPrice, formatTimeTxt } from '../../../services/helpers/Helper';
import { fetchOrder } from '../../../store/action/orderAction';

const Detail = (props) => {
   const { fetchOrder, order } = props;
   const params = useParams();
   const { id } = params;
   useEffect(() => {
      fetchOrder(id)
   }, [id])

   return (
      <div className="cart-container">
         <div className="order_confirm">
            <h5 className="product-title">Mặt hàng</h5>
            <table className="tb_products">
               <tbody>
                  {order.orderProducts.map((item, index) => {
                     return (
                        <tr key={index}>
                           <td>
                              <div>
                                 <img src={imageDefault} className="image-product" />
                              </div>
                           </td>
                           <td>
                              <div className="product-wrapper">
                                 <div className="product-wrapper_item">
                                    <div className="product-wrapper_item_title">{item.product_name}</div>
                                    <div className="product-wrapper_item_price_wrap">
                                       <div className="product-wrapper_item_price">{formatPrice(item.product_price)} ₫</div>
                                       <div className="product-wrapper_item_price_discount"></div>
                                    </div>
                                    <div className="product-wrapper_item_quantity"> <span>x</span> {formatPrice(item.quantity)}</div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                     )
                  })}
               </tbody>
            </table>
            <div className="order-info">
               <h5>Đơn hàng #{order.reference_code}</h5>
               <div className="order-status">
                  <div>{order.status == 1 && "Đang xử lý"}</div>
               </div>
            </div>
            <h5>Ngày đặt hàng</h5>
            <p>{formatTimeTxt(order.order_date)}</p>
            <h5>Thanh toán bằng</h5>
            <p> {order.payment_method_name}</p>
            <h5>Vận chuyển tới</h5>
            <p className="shipping-address">
               {order.shipping_full_name} <br />{order.shipping_address}, {order.shipping_ward_name}, {order.shipping_district_name}, {order.shipping_province_name} <br /> {order.shipping_phone}
            </p>
            <h5>Tóm tắt</h5>
            <table className="tb_order">
               <tbody>
                  <tr>
                     <td>Tổng tiền hàng</td>
                     <td>{formatPrice(order.grand_total)} ₫</td>
                  </tr>
                  <tr>
                     <td>Khuyến mãi</td>
                     <td>0 ₫</td>
                  </tr>
                  <tr>
                     <td>Phí vận chuyển</td>
                     <td>0 ₫</td>
                  </tr>
                  <tr className="bold">
                     <td>Thành tiền</td>
                     <td>{formatPrice(order.grand_total)} ₫</td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { order } = state;
   return {
      order
   };
};

export default connect(mapStateToProps, {
   fetchOrder
})(Detail)
